var printerTypes = {};
var compatiblePrinterTypes = [];
$(document).ready(function() {

    $('.icn-search').on('click touch', function(e){
        e.preventDefault();
        var parent = $(this).closest('div');
        var form = $('.form__search', parent);
        if (form.css('display')=='none') {
            form.show();
        } else {
            form.hide();
        }
    });

    $(document).mouseup(function(e)
    {
        var container = $(".desktop-header .form__search");
        if (container.css('display')=='block') {
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                container.hide();
            }
        }
        var container = $(".desktop-header .main-parent-cart .dropdown");
        if (container.hasClass('open')) {
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                $(".desktop-header .main-parent-cart .dropdown").removeClass('open');
            }
        }

    });

    /*setTimeout(function () {
        if ($('.megamenu__main').length>0 && $('#megamenu-main-content').length>0) {
            $('.megamenu__main').html($('#megamenu-main-content').html());
            $('#megamenu-main-content').remove();
        }
    }, 30);*/

    if ($('body').hasClass('template404')) {

        var parser = new UAParser();

        var params = {
            data: parser.getResult(),
            url: window.location.href
        };

        $.ajax({
            url: 'https://app.breathingcolor.com/track_error',
            method: 'POST',
            data: params,
            dataType: 'json',
            success: function(data) {

            }
        });
    }

    if ($('.custom-nav-tabs').length>0) {
        var url = document.location.toString();
        if (url.match('#')) {
            $('.custom-nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
        }

        // Change hash for page-reload
        $('.custom-nav-tabs a').on('shown.bs.tab', function (e) {
            window.location.hash = e.target.hash;
        });
    }

    if ($('#printer-compatibility-wrapper').length>0) {
        $.ajax({
            url: 'https://app.breathingcolor.com/printertypes/makes',
            method: 'GET',
            dataType: 'json',
            success: function(data) {
                if (data) {
                    $('#make').append('<option value="">- Select Make -</option>');
                    $(data).each(function(i, el){
                        $('#make').append('<option value="'+el+'">'+el+'</option>');
                    });
                }
            }
        });
        $.ajax({
            url: 'https://app.breathingcolor.com/printertypes/all',
            method: 'GET',
            dataType: 'json',
            success: function(data) {
                if (data) {
                    printerTypes = data;
                }
            }
        });
        $.ajax({
            url: 'https://app.breathingcolor.com/products/get-printers/'+meta.product.id,
            method: 'GET',
            dataType: 'json',
            success: function(data) {
                if (data && data.error==0) {
                    compatiblePrinterTypes = data.data;
                }
            }
        });
        $('#make').on('change', function(e) {
            var val = $(this).val();
            var models = printerTypes.filter(function(el) { return el.make==val });
            $('#model').empty();
            $('#model').append('<option value="">- Select Model -</option>');
            $(models).each(function(i, el){
                $('#model').append('<option value="'+el.printer_type_id+'">'+el.name+'</option>');
            });
        });
        $('#printerCompatStartBtn').on('click', function(e){
            e.preventDefault();
            var modelId = parseInt($('#model').val());
            console.log(modelId);
            console.log(compatiblePrinterTypes.includes(modelId));
            $('.result-wrapper').fadeIn();
            if (compatiblePrinterTypes.includes(modelId)) {
                $('.result-wrapper h2, .result-wrapper p').html('Your Printer is Compatible!');
                $('#printer-not-compatible-troducts').fadeOut();
            } else {
                $('.result-wrapper h2, .result-wrapper p').html('Your Printer is NOT Compatible!');
                $('#printer-not-compatible-troducts').fadeIn();
                getPrinterProducts(modelId);
            }

        });
    }

    if ($('#videoContainer').length>0) {

        var tag = document.createElement('script');
        tag.async = true;
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        $('#videoContainer .btn').on('click', function(e){

            e.preventDefault();
            e.stopPropagation();
            $('#bcPlayer').fadeIn();
            $('#videoContainer .btn').fadeOut();
            player.playVideo();
        });

    }

    var lis = $('.custom-description ul li');
    if (lis.length > 3) {
        for (var i = 0; i < lis.length; i++) {
            if (i > 2) {
                $(lis[i]).css({ display: 'none' });
            }
        }
    }

    $('.leftColumn .collapse-block.open:not(.collapse-block-mobile):not(:nth-child(2))').removeClass('open');
    $('.leftColumn .collapse-block:not(.open)').find('.collapse-block_content').hide();

    /*if ($('.promo-discount-box').length > 0) {
        getDiscountPromo(0);
    }

    if ($('.input_variant').length > 0) {
        $('.input_variant').on('change', function(e) {
            checkInputVariantForDiscount();
        });
        setTimeout(() => {
            checkInputVariantForDiscount();
        }, 200);
    }*/

    function checkInputVariantForDiscount() {
        var el = $('.input_variant');
        var form = el.closest('form');
        if (form.length>0) {
            var product_id = form.attr('id').replace('product_form_', '');
            var variant_id = el.val();
            getDiscountPromo(variant_id);
        }
    }

    function getDiscountPromo(variant_id) {
        $('.promo-discount-box').hide();

        var price = parseFloat(
            $('.product-info .price[itemprop="price"] span').html().replace('$', '').replace(',', '')
        );
        $.ajax({
            url:
                'https://app.breathingcolor.com/products/get-automatic-discounts-for-product/' +
                meta.product.id +
                '/' +
                variant_id,
            method: 'GET',
            dataType: 'json',
            success: function(data) {
                $('.promo-discount-box .promo-table').empty();

                if (data.length > 0) {
                    var table_head = $('<thead><tr></tr></thead>');
                    var table_body = $('<tbody><tr></tr></tbody>');
                    $(data).each(function (i, el) {
                        var newPrice = price + el.value * price / 100;
                        table_head.find('tr').append('<th>$' + parseFloat(el.treshold).toFixed(0) + '+</th>');
                        table_body.find('tr').append('<td>$' + newPrice.toFixed(2) + '</td>');
                    });
                    table_head.find('tr').append('<th>$4000+ call for price</th>');
                    table_body.find('tr').append('<td>866-722-6567</td>');

                    $('.promo-table').append(table_head);
                    $('.promo-table').append(table_body);
                    $('.promo-discount-box').show();
                }
            }
        });
    }

    /*if ($('.cart-bottom .pull-right .btn.icon-btn-left').length > 0 || $('#updateform').length > 0) {
        $.ajax({
            url: '/cart.js',
            method: 'GET',
            dataType: 'json',
            success: function(data) {
                if (data) {
                    //send the data to the app
                    var data_str = JSON.stringify(data);

                    $.ajax({
                        url: 'https://app.breathingcolor.com/products/get-discounts-for-cart',
                        method: 'POST',
                        dataType: 'json',
                        data: data_str,
                        success: function(data) {
                            if (data && data.error == 0) {
                                var coupon = data.coupon;
                                if ($('.visible-xs .cart .pull-right .btn.icon-btn-left').length > 0) {
                                    updateCartDataWithDiscount({
                                        data: data,
                                        items_selector: '.visible-xs .cart li.item',
                                        item_price_elem_selector: '.price .price-value',
                                        item_price_selector: '.price .price-value:not(.price-del)',
                                        item_url_selector: '.title-col a',
                                        grandtotal_elem: null,
                                        subtotal_elem: $('.cart-total span'),
                                        quantity_selector: '.qty input'
                                    });

                                    var href = $('.visible-xs .cart .pull-right .btn.icon-btn-left').attr('href');
                                    $('.visible-xs .cart .pull-right .btn.icon-btn-left').attr(
                                        'href',
                                        href + '?discount=' + coupon
                                    );
                                }
                                if ($('.cart-bottom .pull-right .btn.icon-btn-left').length > 0) {
                                    updateCartDataWithDiscount({
                                        data: data,
                                        items_selector: '.main-parent-cart li.item',
                                        item_price_elem_selector: '.price .price-value',
                                        item_price_selector: '.price .price-value:not(.price-del)',
                                        item_url_selector: '.title-col a',
                                        grandtotal_elem: null,
                                        subtotal_elem: $('.cart-total span'),
                                        quantity_selector: '.qty input'
                                    });

                                    var href = $('.cart-bottom .pull-right .btn.icon-btn-left').attr('href');
                                    $('.cart-bottom .pull-right .btn.icon-btn-left').attr(
                                        'href',
                                        href + '?discount=' + coupon
                                    );
                                }
                                if ($('#updateform').length > 0) {
                                    updateCartDataWithDiscount({
                                        data: data,
                                        items_selector: '.shopping-cart-table tbody tr',
                                        item_price_elem_selector: '.product-price.subtotal',
                                        item_price_selector: '.product-price.subtotal:visible:not(.price-del)',
                                        item_url_selector: '.product-title a',
                                        grandtotal_elem: $('#grandtotal td:nth-child(2)'),
                                        subtotal_elem: $('#subtotal .text-right'),
                                        quantity_selector: null
                                    });

                                    if ($('#updateform #discount_code').length == 0) {
                                        $('#updateform').prepend(
                                            '<input type="hidden" name="discount" id="discount_code" value="' +
                                                coupon +
                                                '" />'
                                        );
                                    } else {
                                        $('#discount_code').val(coupon);
                                    }
                                }
                            }
                        }
                    });
                }
            }
        });
    }*/

});

function updateCartDataWithDiscount(opts) {
    var {
        data,
        items_selector,
        item_price_elem_selector,
        item_price_selector,
        item_url_selector,
        grandtotal_elem,
        subtotal_elem,
        quantity_selector
    } = opts;

    var total = 0;
    $(items_selector).each(function(i, el) {
        var priceEl = $(el).find(item_price_elem_selector);
        var priceInnerEl = $(el).find(item_price_selector);
        if (priceInnerEl && priceInnerEl.length == 1) {
            var price = parseFloat(priceInnerEl.html().replace('$', '').replace(',', ''));
            var newPrice = price;
            var parts = $(el).find(item_url_selector).attr('href').split('?');
            var qty = 1;
            if (quantity_selector && $(el).find(quantity_selector).length == 1) {
                qty = parseInt($(el).find(quantity_selector).val());
            }
            if (parts.length > 1) {
                var parts2 = parts[1].split('&');
                var parts3 = parts2[0].split('=');
                if (parts3[0] == 'variant') {
                    var variant_id = parts3[1];
                    if (data.variant_ids.includes(variant_id)) {
                        var treshold = parseFloat(data.treshold).toFixed(0);
                        newPrice = price + data.value * price / 100;
                        priceEl.addClass('price-del');
                        priceEl.after(
                            '<div class="product-price new-price">$' +
                                newPrice.toFixed(2) +
                                ' <small>(+$' +
                                treshold +
                                ' disc.)</small>' +
                                '</div>'
                        );
                    }
                }
            }
            total += newPrice * qty;
        }
    });
    var subtotal = parseFloat(subtotal_elem.html().replace('$', '').replace(',', ''));
    subtotal_elem.html('$' + total.toFixed(2));

    if (grandtotal_elem && grandtotal_elem.length > 0) {
        var grandtotal = parseFloat(grandtotal_elem.html().replace('$', '').replace(',', ''));
        var grandtotal_diff = grandtotal - subtotal;
        var newGrandtotal = total + grandtotal_diff;
        grandtotal_elem.html('$' + newGrandtotal.toFixed(2));
    }
}

// 3. This function creates an <iframe> (and YouTube player)
//    after the API code downloads.
var player;
function onYouTubeIframeAPIReady() {
    player = new YT.Player('bcPlayer', {
        height: '315',
        width: '560',
        videoId: '9Cy8h1A2dww',
        playerVars: {rel: 0, showinfo: 0, ecver: 2},
        events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
        }
    });
}

var done = false;
// 4. The API will call this function when the video player is ready.
function onPlayerReady(event) {
    //event.target.playVideo();
}

// 5. The API calls this function when the player's state changes.
//    The function indicates that when playing a video (state=1),
//    the player should play for six seconds and then stop.

function onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.PLAYING && !done) {
        done = true;
    }
    if (event.data == YT.PlayerState.ENDED && done) {
        $('#bcPlayer').fadeOut();
        $('#videoContainer .btn').fadeIn();
    }
    /*if (event.data == YT.PlayerState.PAUSED && done) {
        setTimeout(function(){
            $('.slideshow-classic').flickity('playPlayer');
            $('.slideshow-classic').flickity('next');
        }, 1000);

    }*/
}
function stopVideo() {
    player.stopVideo();
}

function getPrinterProducts(printerTypeId) {
    $('#printer-related-products').html('Loading compatible products ...');
    $.ajax({
        url: 'https://app.breathingcolor.com/products/printer-similar-products/'+meta.product.id+'/'+printerTypeId,
        method: 'GET',
        dataType: 'json',
        success: function(obj) {
            console.log(obj);

            $('#printer-related-products').empty();
            if (obj.error==0 && obj.data) {
                $(obj.data).each(function(i, el) {
                    loadProductThumb(el);
                });
            }
        }
    });
}

function loadProductThumb(handle) {

    $.ajax({
        url: 'https://www.breathingcolor.com/search?type=product&q='+handle,
        method: 'GET',
        dataType: 'html',
        success: function(html) {
            if ($('.product', $(html)).length>0) {
                var pHtml = $('.product', $(html))[0].outerHTML;
                $('#printer-related-products').append('<div class="col-md-4">' + pHtml + '</div>');
                //console.log(pHtml);
            }
        }
    });
}
